// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedBenEnrollmentDemographicsModel {
    static getAttributeTypeMap() {
        return MedBenEnrollmentDemographicsModel.attributeTypeMap;
    }
}
MedBenEnrollmentDemographicsModel.discriminator = undefined;
MedBenEnrollmentDemographicsModel.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "string"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<EnrollmentPhoneNumberModel>"
    },
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "address2",
        "baseName": "address2",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "postalCode",
        "baseName": "postalCode",
        "type": "string"
    },
    {
        "name": "country",
        "baseName": "country",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "communicationTypes",
        "baseName": "communicationTypes",
        "type": "Array<TCSCommunicationType>"
    },
    {
        "name": "communicationOption",
        "baseName": "communicationOption",
        "type": "TCSCommunicationOption"
    },
    {
        "name": "paymentType",
        "baseName": "paymentType",
        "type": "TCSPaymentType"
    },
    {
        "name": "householdSize",
        "baseName": "householdSize",
        "type": "number"
    },
    {
        "name": "medicalMemberNumber",
        "baseName": "medicalMemberNumber",
        "type": "string"
    }
];
//# sourceMappingURL=medBenEnrollmentDemographicsModel.js.map